export default "__VITE_ASSET__A8GQ5Vci__"